'use es6';

import { getIsSwitchingBetweenFormattingModes } from 'forms-utils-lib/language/getIsSwitchingBetweenFormattingModes';
import FormStyleKeys from 'forms-utils-lib/constants/formStyle/FormStyleKeys';
import updateFormStyleKey from 'forms-utils-lib/formStyle/utils/updateFormStyleKey';
import getTranslatedDefaultThankYouMessage from 'FormsUI/utils/translation/getTranslatedDefaultThankYouMessage';
import { getReverseLangDirection } from 'FormsUI/utils/LangDirectionUtils';
import { getDefinition } from 'FormsUI/selectors/FormDefinition';
import { updateFormValue } from 'FormsUI/actions/FormDefinition';
const createAction = name => `@@formDefinition/${name}`;
export const START_TRANSLATE_THANK_YOU_MESSAGE = createAction('START_TRANSLATE_THANK_YOU_MESSAGE');
export const END_TRANSLATE_THANK_YOU_MESSAGE = createAction('END_TRANSLATE_THANK_YOU_MESSAGE');
const translateThankYouMessage = (oldLocale, newLocale) => (dispatch, getState) => {
  dispatch({
    type: START_TRANSLATE_THANK_YOU_MESSAGE,
    oldLocale,
    newLocale
  });
  const state = getState();
  const formDefinition = getDefinition(state);
  const translatedDefaultInlineMessage = getTranslatedDefaultThankYouMessage({
    inlineMessage: formDefinition.inlineMessage,
    newLocale,
    oldLocale
  });
  if (translatedDefaultInlineMessage) {
    dispatch(updateFormValue({
      inlineMessage: translatedDefaultInlineMessage
    }));
  }
  if (getIsSwitchingBetweenFormattingModes(oldLocale, newLocale) && formDefinition.style && formDefinition.style.submitAlignment) {
    dispatch(updateFormValue({
      style: updateFormStyleKey(formDefinition.style, FormStyleKeys.SUBMIT_ALIGNMENT, getReverseLangDirection(formDefinition.style.submitAlignment))
    }));
  }
  dispatch({
    type: END_TRANSLATE_THANK_YOU_MESSAGE,
    oldLocale,
    newLocale
  });
};
export default translateThankYouMessage;